import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const areaParamsSchema = object({
  areaId: stringToNumber()
})
